import { render } from "./SlideOverPanelWide.vue?vue&type=template&id=5db2d348"
import script from "./SlideOverPanelWide.vue?vue&type=script&lang=js"
export * from "./SlideOverPanelWide.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__